import {CountryInterface} from "../interfaces/country.interface";
import {FlagSize, ImageFormat, UrlString} from "../types.type";
import {CountryCodes} from "../enums/country-codes.enum";
import {COUNTRY_NAMES, FLAGS_URL} from "../constants/country-names.constant";

export class CountryClass implements CountryInterface {
    static flagURL = FLAGS_URL;

    public countryName: string;
    public countryFlag: UrlString;

    constructor(public countryCode: CountryCodes) {
        this.countryName = this._setCountryName();
        this.countryFlag = this._getCountryFlagUrl();
    }

    private _getCountryFlagUrl(size: FlagSize = '16x12', format: ImageFormat = 'webp') {
        return CountryClass.flagURL + '/' + size + '/' + this.countryCode + '.' + format; // https://flagcdn.com/16x12/gr.webp
    }

    private _setCountryName() {
        const countryIndex = Object.keys(COUNTRY_NAMES).findIndex(key => key === this.countryCode.toUpperCase());
        return Object.values(COUNTRY_NAMES).at(countryIndex) || '';
    }
}
